<template>
    <v-btn
        color="primary"
        class="back-button"
        @click="navigateHome"
    >
        <v-icon left>mdi-arrow-left</v-icon>
        Packlisten
    </v-btn>
</template>

<script>
export default {
    name: 'BackButton',
    methods: {
        async navigateHome() {
            if (document.fullscreenElement) {
                try {
                    await document.exitFullscreen();
                } catch (error) {
                    console.warn('Error exiting fullscreen:', error);
                }
            }
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.back-button {
    text-transform: none;
}
</style>
